/**
 * ExportCsvButton — the ONE "Export CSV" button for every list page (Agreements, Persons,
 * Accounts, Insurance Policies; Pedro 2026-10-10, one app language). The export mirrors the
 * list as filtered: the caller builds `href` from the same params as the list query.
 *
 * Bulk exports are Admin-only (C-335). Other roles do not see the button at all (Pedro
 * 2026-10-10: "Users not privileged to download do not need to see the button" — app-language
 * D7). With no status pill selected there is nothing to export (#39), so it greys with that hint.
 */
import { Button } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';

import { useCurrentUser } from '../hooks/useAuth';
import { NO_STATUS_SELECTED_HINT } from './StatusFilterPills';

export function ExportCsvButton({ href, hasSelection }: { href: string; hasSelection: boolean }) {
  const { user } = useCurrentUser();
  if (user?.role !== 'admin') return null;
  return (
    <Button
      variant="default"
      leftSection={<IconDownload size={16} />}
      component="a"
      href={href}
      disabled={!hasSelection}
      title={hasSelection ? undefined : NO_STATUS_SELECTED_HINT}
    >
      {/* An Excel workbook since 2026-10-20 (Pedro: the CSV's "·" / "…" came out garbled
          in Excel); the component keeps its name. The audit log's export stays CSV. */}
      Export Excel
    </Button>
  );
}
